export function navDropdown() {
  /**
   * Main nav, side nav dropdown open
   */
  if (document.querySelector(".side-nav li.menu-item-has-children")) {
    document
      .querySelectorAll(".side-nav li.menu-item-has-children > a")
      .forEach((a) =>
        a.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          // e.target.parentElement.classList.toggle( 'open' )
        })
      );
  }
}
